import React from 'react';
import '../../style/scss/selectionPanel.scss'; // Updated to use SCSS instead of CSS
//import {DateTime} from "luxon";
import { MdCheckBoxOutlineBlank, MdOutlineCheckBox } from "react-icons/md";

export default function EmploymentTypeSelectionListItem(props) {
   const onClick = (e) => {
      if (props.onClick) {
         props.onClick(props.employmentType.Key, e);
      }
      if (props.onChange) {
         props.onChange(props.employmentType.Key, e);
      }
   }
   return (
      <div className={"EmploymentType selectionPanel checkRow" + (props.selected ? ' selected' : '')} 
           id={props.employmentType.Key} 
           onClick={onClick}>
         <span className='icon'>
            <MdCheckBoxOutlineBlank size={1} color="#0075FF" className={props.selected ? 'hidden' : ''} />
            <MdOutlineCheckBox size={1} color="#0075FF" className={props.selected ? '' : 'hidden'} />
         </span>
         <span className='title'>{props.employmentType.Value}</span>
         <span className='byline'></span>
         <span className='rightText'></span>
      </div>
   );
}

